module.exports = __webpack_public_path__ + "static/media/intro_icon_5.1a6907a7.svg";